export const MOST_RECENT_ARTICLES_REQUEST = "MOST_RECENT_ARTICLES_REQUEST";
export const MOST_RECENT_ARTICLES_SUCCESS = "MOST_RECENT_ARTICLES_SUCCESS";
export const MOST_RECENT_ARTICLES_FAIL = "MOST_RECENT_ARTICLES_FAIL";

export const COUNTRY_REDIRECT_SUCCESS = "COUNTRY_REDIRECT_SUCCESS";
export const COUNTRY_REDIRECT_REQUEST = "COUNTRY_REDIRECT_REQUEST";
export const COUNTRY_REDIRECT_FAIL = "COUNTRY_REDIRECT_FAIL";

export const GET_USER_EMAIL = "GET_USER_EMAIL";
export const GET_USER_COMPANY_INFO = "GET_USER_COMPANY_INFO";
export const GET_USER_PERSONAL_INFO = "GET_USER_PERSONAL_INFO";

export const DUPLICATE_EMAIL_REQUEST = "DUPLICATE_EMAIL_REQUEST";
export const DUPLICATE_EMAIL_SUCCESS = "DUPLICATE_EMAIL_SUCCESS";
export const DUPLICATE_EMAIL_FAIL = "DUPLICATE_EMAIL_FAIL";

export const SEND_DATA_REQUEST = "SEND_DATA_REQUEST";
export const SEND_DATA_SUCCESS = "SEND_DATA_SUCCESS";
export const SEND_DATA_FAIL = "SEND_DATA_FAIL";

export const GET_IPDATA_REQUEST = "GET_IPDATA_REQUEST";
export const GET_IPDATA_SUCCESS = "GET_IPDATA_SUCCESS";
export const GET_IPDATA_FAIL = "GET_IPDATA_FAIL";

export const GET_PAGE_NAME = "GET_PAGE_NAME";
export const GET_PAGE_NAME_FAIL = "GET_PAGE_NAME_RESET";

export const GET_NEWS_USER_INFO = "GET_NEWS_USER_INFO";
export const GET_NEWS_USER_INFO_FAIL = "GET_NEWS_USER_INFO_FAIL";

export const POST_NLSUB_REQ = "POST_NLSUB_REQ";
export const POST_NLSUB_SUCCESS = "POST_NLSUB_SUCCESS";
export const POST_NLSUB_FAIL = "POST_NLSUB_FAIL";

export const SEND_TWILIO_REQ = "SEND_TWILIO_REQ";
export const SEND_TWILIO_FAIL = "SEND_TWILIO_FAIL";
export const SEND_TWILIO_SUCCESS = "SEND_TWILIO_SUCCESS";

export const SEND_NEWSLETTER_DATA_REQ = "SEND_NEWSLETTER_DATA_REQ";
export const SEND_NEWSLETTER_DATA_SUCCESS = "SEND_NEWSLETTER_DATA_SUCCESS";
export const SEND_NEWSLETTER_DATA_FAIL = "SEND_NEWSLETTER_DATA_FAIL";

export const FREETRIAL_CREATE_REQ = "FREETRIAL_CREATE_REQ";
export const FREETRIAL_CREATE_SUCCESS = "FREETRIAL_CREATE_SUCCESS";
export const FREETRIAL_CREATE_FAIL = "FREETRIAL_CREATE_FAIL";

export const REDIRECT_STATUS_CHECKED = "REDIRECT_STATUS_CHECKED";

export const FIRST_VISIT_COUNTER = "FIRST_VISIT_COUNTER";
export const FIRST_VISIT_TRUE = "FIRST_VISIT_TRUE";

export const SEND_EMAIL_REQ = "SEND_EMAIL_REQ";
export const SEND_EMAIL_SUCCESS = "SEND_EMAIL_SUCCESS";
export const SEND_EMAIL_FAIL = "SEND_EMAIL_FAIL";

export const SUB_TO_PRODUCT_LIST_REQ = "SUB_TO_PRODUCT_LIST_REQ";
export const SUB_TO_PRODUCT_LIST_SUCCESS = "SUB_TO_PRODUCT_LIST_SUCCESS";
export const SUB_TO_PRODUCT_LIST_FAIL = "SUB_TO_PRODUCT_LIST_FAIL";

export const SEND_NOTIFICATION_UK_REQ = "SEND_NOTIFICATION_UK_REQ";
export const SEND_NOTIFICATION_UK_SUCCESS = "SEND_NOTIFICATION_UK_SUCCESS";
export const SEND_NOTIFICATION_UK_FAIL = "SEND_NOTIFICATION_UK_FAIL";

export const SEND_CHILI_REQ = "SEND_CHILI_REQ";
export const SEND_CHILI_SUCCESS = "SEND_CHILI_SUCCESS";
export const SEND_CHILI_FAIL = "SEND_CHILI_FAIL";
